// Mirrors AlertCDS.styles.js's getAlertStyles — pale variant-tinted surface with dark-variant text
// in light mode; a dark elevated surface with a variant-colored border in dark mode.
export const getBannerStyles = variant => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '12px',
  padding: '16px',
  borderRadius: ({ shape }) => shape.radius.l,
  backgroundColor: ({ palette }) =>
    palette.mode === 'dark' ? palette.background.paper : palette[variant]?.extraSoft,
  border: ({ palette }) =>
    palette.mode === 'dark' ? `1px solid ${palette[variant]?.main}` : 'none',
});

// In light mode the surface is a pale variant tint, so the readable text is the deep `.dark` shade.
// In dark mode the surface is `background.paper`, so `.dark` (e.g. info.dark #1F6BE0) drops to ~3.3:1
// and fails WCAG — flip to the bright `.light` shade of the variant for legible text on the dark panel.
export const getBannerTextStyles = variant => ({
  color: ({ palette }) =>
    palette.mode === 'dark' ? palette[variant]?.light : palette[variant]?.dark,
});

export const iconStyles = {
  flex: 'none',
  marginTop: '2px',
};

export const textWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
};
